import type { ImageValue } from '@elfsight/configurator-contracts';
import { CTAButtonType } from './location-card-types';

export const CTAButtonTypeStyles: Record<
  string,
  { icon: ImageValue; configuratorIcon?: ImageValue; color?: string }
> = {
  [CTAButtonType.custom]: {
    icon: null
  },
  [CTAButtonType.call]: {
    icon: { url: 'https://static.elfsight.com/icons/phone.svg' }
  },
  [CTAButtonType.directions]: {
    icon: {
      url: 'https://static.elfsight.com/icons/directions.svg'
    }
  },
  [CTAButtonType.share]: {
    icon: {
      url: 'https://static.elfsight.com/icons/share.svg'
    }
  },
  [CTAButtonType.message]: {
    icon: {
      url: 'https://static.elfsight.com/icons/comment.svg'
    }
  },
  [CTAButtonType.book]: {
    icon: {
      url: 'https://static.elfsight.com/icons/calendar.svg'
    }
  },
  [CTAButtonType.order]: {
    icon: {
      url: 'https://static.elfsight.com/icons/shopping-bag-2.svg'
    }
  },
  [CTAButtonType.menu]: {
    icon: {
      url: 'https://static.elfsight.com/icons/menu-book.svg'
    }
  },
  [CTAButtonType.pricing]: {
    icon: {
      url: 'https://static.elfsight.com/icons/price-tag-outlined.svg'
    }
  },
  [CTAButtonType.booking]: {
    color: '#003581',
    icon: {
      url: 'https://static.elfsight.com/icons/booking.svg'
    },
    configuratorIcon: {
      url: 'https://static.elfsight.com/icons/booking-multicolor.svg'
    }
  },
  [CTAButtonType.whatsapp]: {
    color: '#14C656',
    icon: {
      url: 'https://static.elfsight.com/icons/whatsapp.svg'
    },
    configuratorIcon: {
      url: 'https://static.elfsight.com/icons/whatsapp-multicolor.svg'
    }
  },
  [CTAButtonType.tripadvisor]: {
    color: '#00B485',
    icon: {
      url: 'https://static.elfsight.com/icons/tripadvisor.svg'
    },
    configuratorIcon: {
      url: 'https://static.elfsight.com/icons/tripadvisor-multicolor.svg'
    }
  },
  [CTAButtonType.opentable]: {
    color: '#DA2F36',
    icon: {
      url: 'https://static.elfsight.com/icons/opentable.svg'
    },
    configuratorIcon: {
      url: 'https://static.elfsight.com/icons/opentable-multicolor.svg'
    }
  },
  [CTAButtonType.yelp]: {
    color: '#D42322',
    icon: {
      url: 'https://static.elfsight.com/icons/yelp.svg'
    },
    configuratorIcon: {
      url: 'https://static.elfsight.com/icons/yelp-multicolor.svg'
    }
  },
  [CTAButtonType.ubereats]: {
    color: '#000000',
    icon: {
      url: 'https://static.elfsight.com/icons/ubereats.svg'
    },
    configuratorIcon: {
      url: 'https://static.elfsight.com/icons/ubereats-multicolor.svg'
    }
  }
};
